import React from "react";
import {Link, useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import QButton from "../../../../common/components/QButton";
import {RouteDefine} from "../../../../routes/RouteDefine";
import {getSettingsEconomicPath} from "../../../../routes/settingsPaths";

type DashboardHealthStripProps = {
    stripeConnected: boolean;
    economicConnected: boolean;
    incompleteSetupCount: number;
    firstIncompleteSection?: string | null;
    compact?: boolean;
};

const DashboardHealthStrip: React.FC<DashboardHealthStripProps> = ({
    stripeConnected,
    economicConnected,
    incompleteSetupCount,
    firstIncompleteSection,
    compact = false,
}) => {
    const {t} = useTranslation();
    const history = useHistory();

    const connectionOk = stripeConnected && economicConnected;
    const setupOk = incompleteSetupCount === 0;

    // Avoid duplicating the welcome banner when nothing is connected yet.
    if (compact && !connectionOk) {
        return null;
    }

    return (
        <div className="col-12 mb-3">
            <div className="business-detail bg-orange-bland-zp bdr-20 pd-25">
                <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <span className="fw-semibold me-1">{t("common.dashboard.healthTitle")}</span>
                        <span className={`badge ${stripeConnected ? "bg-success" : "bg-secondary"}`}>
                            Stripe · {stripeConnected ? t("common.settingsOverview.connected") : t("common.settingsOverview.notConnected")}
                        </span>
                        <span className={`badge ${economicConnected ? "bg-success" : "bg-secondary"}`}>
                            e-conomic · {economicConnected ? t("common.settingsOverview.connected") : t("common.settingsOverview.notConnected")}
                        </span>
                        {!setupOk ? (
                            <span className="badge bg-warning text-dark">
                                {t("common.dashboard.setupIncompleteCount", {count: incompleteSetupCount})}
                            </span>
                        ) : connectionOk ? (
                            <span className="badge bg-success">{t("common.dashboard.readyToSync")}</span>
                        ) : null}
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                        {!connectionOk ? (
                            <Link to={RouteDefine.settings} className="btn btn-sm btn-primary">
                                {t("common.dashboard.openSettings")}
                            </Link>
                        ) : null}
                        {!setupOk && firstIncompleteSection ? (
                            <QButton
                                type="primary"
                                className="btn-sm"
                                content={t("common.dashboard.fixSetup")}
                                onClick={() => history.push(`${getSettingsEconomicPath()}?setup=${firstIncompleteSection}`)}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DashboardHealthStrip);
